<template>
  <v-container fluid class="ai-page">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-select
          outlined
          dense
          hide-details
          background-color="white"
          prepend-inner-icon="mdi-domain"
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Empresa"
          @input="carregaPaineis(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>

    <v-card class="ai-panel" :class="{ 'mt-3': user.tipo == 'ADMIN' }" elevation="0">
      <div class="ai-panel__head">
        <div class="ai-panel__title">
          <v-icon>mdi-television-classic</v-icon>
          Painéis
          <span class="ai-count">{{ tabela.conteudo.length }}</span>
        </div>
        <div class="ai-panel__spacer"></div>
        <v-text-field
          v-model="tabela.busca"
          append-icon="mdi-magnify"
          label="Procurar"
          single-line
          hide-details
          dense
          outlined
          class="ai-search"
        ></v-text-field>
        <v-btn color="primary" depressed @click="dialogoPainel = true" v-if="user.tipo == 'ADMIN'">
          <v-icon left>mdi-plus</v-icon>Cadastrar
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="description"
        class="ai-datatable"
        :footer-props="{ 'items-per-page-text': 'Linhas por página', 'items-per-page-all-text': 'Tudo' }"
        :loading="tabela.carregamento"
        loading-text="Buscando itens..."
      >
        <template v-slot:[`item.macAddress`]="{ item }">
          <code class="ai-mac">{{ item.macAddress }}</code>
        </template>
        <template v-slot:[`item.isOnline`]="{ item }">
          <span class="ai-status" :class="item.isOnline ? 'success--text' : 'error--text'">
            <v-icon x-small :color="item.isOnline ? 'success' : 'error'">mdi-circle</v-icon>
            {{ item.isOnline ? 'Ativo' : 'Inativo' }}
          </span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="atualizarItem(item)"><v-icon color="warning">mdi-reload</v-icon></v-btn>
            </template>
            <span>Atualizar painel</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="editItem(item)"><v-icon color="info">mdi-pencil</v-icon></v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="deleteItem(item)"><v-icon color="error">mdi-delete</v-icon></v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <div class="py-6">
            <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dense text outlined color="info" class="ma-0 d-inline-flex">
              <v-icon left color="info">mdi-information</v-icon>Selecione uma empresa para visualizar os painéis
            </v-alert>
            <v-alert v-else dense text outlined color="warning" class="ma-0 d-inline-flex">
              <v-icon left color="warning">mdi-television-off</v-icon>Nenhum painel cadastrado
            </v-alert>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogoPainel" persistent max-width="600px" scrollable class="ai-dialog">
      <v-card>
        <v-card-title><v-icon>mdi-television-classic</v-icon>{{ formTitle }}</v-card-title>
        <v-card-text class="ai-dialog-body">
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.description"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Endereço MAC*" outlined dense hide-details v-model="editedItem.macAddress" v-mask="'XX:XX:XX:XX:XX:XX'"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-switch v-model="editedItem.isOnline" label="Ativo*" inset hide-details class="mt-1"></v-switch>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="Cor de fundo do painel*" outlined dense hide-details v-model="editedItem.bgPainelColor">
                    <template v-slot:append><v-icon :color="editedItem.bgPainelColor">mdi-square-rounded</v-icon></template>
                  </v-text-field>
                </template>
                <v-color-picker dot-size="8" hide-canvas hide-inputs hide-sliders show-swatches swatches-max-height="200" v-model="editedItem.bgPainelColor"></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="Cor de fundo do leito*" outlined dense hide-details v-model="editedItem.bgLeitoColor">
                    <template v-slot:append><v-icon :color="editedItem.bgLeitoColor">mdi-square-rounded</v-icon></template>
                  </v-text-field>
                </template>
                <v-color-picker dot-size="8" hide-canvas hide-inputs hide-sliders show-swatches swatches-max-height="200" v-model="editedItem.bgLeitoColor"></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="Cor de texto do painel*" outlined dense hide-details v-model="editedItem.textPainelColor">
                    <template v-slot:append><v-icon :color="editedItem.textPainelColor">mdi-square-rounded</v-icon></template>
                  </v-text-field>
                </template>
                <v-color-picker dot-size="8" hide-canvas hide-inputs hide-sliders show-swatches swatches-max-height="200" v-model="editedItem.textPainelColor"></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="Cor de texto do leito*" outlined dense hide-details v-model="editedItem.textLeitoColor">
                    <template v-slot:append><v-icon :color="editedItem.textLeitoColor">mdi-square-rounded</v-icon></template>
                  </v-text-field>
                </template>
                <v-color-picker dot-size="8" hide-canvas hide-inputs hide-sliders show-swatches swatches-max-height="200" v-model="editedItem.textLeitoColor"></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                outlined
                dense
                hide-details
                chips
                small-chips
                deletable-chips
                label="Chamadores"
                v-model="editedItem.chamadores"
                :items="chamadores"
                :item-text="item => item.nome + ' (' + item.descricao + ' ' + item.numero + ')'"
                item-value="id"
                multiple
              >
                <template slot="item" slot-scope="data">
                  {{ data.item.nome }} ({{ data.item.descricao }} {{ data.item.numero }})
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoPainel = false">Fechar</v-btn>
          <v-btn depressed color="primary" @click="salvarUsuario" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn depressed color="primary" @click="editarUsuario" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#038b8b" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'description', },
          { text: 'Endereço MAC', value: 'macAddress' },
          { text: 'Ativo', value: 'isOnline' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      sexos: [
        { text: 'Masculino', value: 'MASCULINO' },
        { text: 'Feminino', value: 'FEMININO' },
      ],
      dialogoPainel: false,
      editedIndex: -1,
      editedItem: {
        description: '',
        bgPainelColor: '#45B7C2',
        bgLeitoColor: '#388E3C',
        textPainelColor: '#606060',
        textLeitoColor: '#606060',
        isOnline: true,
        macAddress: '',
        chamadores: [],
        empresaId: '',
      },
      defaultItem: {
        description: '',
        bgPainelColor: '#45B7C2',
        bgLeitoColor: '#388E3C',
        textPainelColor: '#606060',
        textLeitoColor: '#606060',
        isOnline: true,
        macAddress: '',
        chamadores: [],
        empresaId: '',
      },
      chamadores: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo painel' : 'Editar painel'
      },
    }),

    watch: {
      dialogoPainel(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaPaineis(this.empresaSelecionada)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaPaineis(this.companyobj.id)
      }

    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaPaineis(id) {
        this.carregaChamadores(id)
        this.tabela.conteudo = []
        this.tabela.carregamento = true
        await axios.get(baseApiUrl + 'Paineis?filter={"where":{"empresaId":"' + id + '"}, "order": "descricao ASC"}')
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
        })
      },

      async carregaChamadores(id) {
        this.chamadores = []
        await axios.get(baseApiUrl + 'Chamadores?filter={"where":{"empresaId":"' + id + '"}, "order": "numero ASC", "fields":{"nome": true, "descricao": true, "numero": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.chamadores = response.data
          }
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoPainel = true
        this.isLoading = false
      },

      async salvarUsuario() {
        var vm = this;
        if (!this.editedItem.description || !this.editedItem.macAddress || !this.editedItem.isOnline || this.editedItem.chamadores.length == 0 || !this.editedItem.bgPainelColor || !this.editedItem.bgLeitoColor || !this.editedItem.textPainelColor || !this.editedItem.textLeitoColor) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada
          await axios.post(baseApiUrl + 'Paineis?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              if (response.data) {
                this.dialogoPainel = false
                vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
                this.carregaPaineis(this.empresaSelecionada)
              }
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FF0000", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
          this.isLoading = false
        }
      },

      async editarUsuario() {
        var vm = this;
        if (!this.editedItem.description || !this.editedItem.macAddress || !this.editedItem.isOnline || this.editedItem.chamadores.length == 0 || !this.editedItem.bgPainelColor || !this.editedItem.bgLeitoColor || !this.editedItem.textPainelColor || !this.editedItem.textLeitoColor) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          await axios.put(baseApiUrl + 'Paineis/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoPainel = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaPaineis(this.empresaSelecionada)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "#BF4554")
          })
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o painel ' + item.descricao + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Paineis/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaPaineis(this.empresaSelecionada)
          })
        }
      },

      async atualizarItem(item) {
        let vm = this;

        await axios.post(baseApiUrl + 'Paineis/notificaPainel?access_token=' + sessionStorage.getItem('accToken'), {"empresaId": item.empresaId})
        .then(() => {
          vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
          this.carregaPaineis(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
        })
      },
    },
  }
</script>

<style scoped>
.ai-mac {
  background: #f1f4f9;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.82rem;
  color: #2b3674;
}
</style>
